import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useCommonStyles } from '../../../../styles';
import { useStyles } from './styles';
import { RevokeRepresentativeIcon } from '../../../../components';

interface Props {
  open: boolean;
  translation: any;
  onClose: () => void;
  onRevoke: () => void;
}

export const RevokeRepresentativeDialog: FC<Props> = ({ open, translation, onClose, onRevoke }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.dialog }}>
      <DialogTitle disableTypography className={commonClasses.dialogHeader}>
        <Grid container spacing={1} justify="flex-end">
          <IconButton className={commonClasses.dialogCloseBtn} style={{ padding: 0 }} onClick={() => onClose()}>
            <Close />
          </IconButton>
        </Grid>
      </DialogTitle>
      <Grid container direction="column" alignItems="center" justify="center" className={classes.dialogContent} spacing={1}>
        <Grid item>
          <RevokeRepresentativeIcon />
        </Grid>
        <Grid item>
          <Typography className={commonClasses.dialogTitle}>{translation.text_6518}</Typography>
        </Grid>
        <Grid item>
          <Typography className={commonClasses.dialogBody}>{translation.text_6519}</Typography>
        </Grid>
      </Grid>
      <DialogActions className={commonClasses.dialogAction}>
        <Button onClick={onRevoke} fullWidth className={commonClasses.negativeDialogBtn}>
          {translation.text_6527}
        </Button>
        <Button onClick={handleClose} fullWidth className={commonClasses.cancelDialogBtn}>
          {translation.text_141}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
